module.exports = __webpack_public_path__ + "static/img/contactfranchise1.017acf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contactfranchise1.jpg
// module id = ylxg
// module chunks = 1